import { observable, computed, action } from 'mobx';
import TableRow from './TableRow';

class TableRows {
    @observable items;
    @observable status;

    rowsMap = {};

    constructor (data, rowType, keyValue) {
        this.extraItems = []; // Should be limited.
        this.maxExtraItems = 20;

        if (data === 'error') {
            this.items = [];
            this.status = 'error';
            return;
        }

        if (data === undefined) {
            this.items = [];
            this.status = 'loading';
            return;
        }

        this.items = data.map((item, i) => {
            const key = item[keyValue];
            const newRow = new TableRow(item, rowType);

            this.rowsMap[key] = i;
            return newRow;
        });
    }

    @action updateTableRow (data) {
        const key = data.key;
        const ind = this.rowsMap[key];

        const item = this.items[ind];

        if (item) {
            this.items[ind].incrementAmount(data);
        } else {
            this.addItem(data);
        }
    }

    @action addItem (item) {
        this.extraItems.push(item);
        if (this.extraItems.length > this.maxExtraItems) {
            this.extraItems.splice(0, this.maxExtraItems);
        }
    }
}

export default TableRows;



// WEBPACK FOOTER //
// ./src/app/models/TableRows.js